import { render, staticRenderFns } from "./Oushi.vue?vue&type=template&id=a965f766&scoped=true&"
import script from "./Oushi.vue?vue&type=script&lang=js&"
export * from "./Oushi.vue?vue&type=script&lang=js&"
import style0 from "./Oushi.vue?vue&type=style&index=0&id=a965f766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a965f766",
  null
  
)

export default component.exports